import React, { createContext, useState } from 'react';

const data = {
  collar: {
    id: '',
    label: '',
    value: '',
    img: '',
    cleric_type: [
      {
        id: '',
        label: '',
        value: ''
      }
    ]
  },
  back: {
    id: '',
    value: '',
    label: '',
    img: ''
  },
  cuffs: {
    id: '',
    value: '',
    label: '',
    img: '',
    cuffs_type: [
      {
        id: '',
        label: '',
        value: ''
      }
    ]
  },
  plackets: {
    id: '',
    value: '',
    label: '',
    img: ''
  },
  pocket: {
    id: '',
    value: '',
    label: '',
    img: ''
  },
  button: {
    id: '',
    value: '',
    label: '',
    img: ''
  },
  sizes: {
    base: {
      id: '',
      label: ''
    },
    chest_size: {
      id: '',
      label: '',
      value: ''
    },
    collar_size: {
      id: '',
      label: '',
      value: ''
    },
    body_length: {
      id: '',
      label: '',
      value: ''
    },
    sleeve_length_left: {
      id: '',
      label: '',
      value: ''
    },
    sleeve_length_right: {
      id: '',
      label: '',
      value: ''
    },
    cuffs_width_left: {
      id: '',
      label: '',
      value: ''
    },
    cuffs_width_right: {
      id: '',
      label: '',
      value: ''
    },
    waist_size: {
      id: '',
      label: '',
      value: ''
    },
    yoke_size: {
      id: '',
      label: '',
      value: ''
    },
    sleeve_width: {
      id: '',
      label: '',
      value: ''
    }
  },
  embroideryOptions: {
    embroidery: {
      value: ''
    },
    embroidery_color: {
      id: '',
      value: '',
      img: ''
    },
    embroidery_type: {
      id: '',
      value: '',
      img: ''
    },
    embroidery_place: {
      id: '',
      value: '',
      img: ''
    },
    embroidery_format: {
      id: '',
      value: ''
    },
    embroidery_initial: {
      value: ''
    }
  },
  brand_name: {
    id: '',
    value: '',
    label: ''
  },
  kamakura_name: {
    id: '',
    value: '',
    label: ''
  }
};
const CustomizeContext = createContext(data);

const CustomizeProvider = (props) => {
  const [customizes, setCustomizeForm] = useState(data);

  const setCustomizes = (data) => {
    setCustomizeForm(data);
  };

  return (
    <CustomizeContext.Provider value={{ customizes, setCustomizes }}>
      {props.children}
    </CustomizeContext.Provider>
  );
};

export { CustomizeContext, CustomizeProvider };
